// Close all other facets when one is opened
export function closeSiblingFacets(currentButton) {
    const allOpenFacets = document.querySelectorAll('.collapsible-trigger.is-open')
    allOpenFacets.forEach((openFacet) => {
        // Skip the current button
        if (openFacet !== currentButton) {
            openFacet.click()
        }
    })
}

// Helper functions for product tag and custom field operations
export const hasTag = (product, tagName) => {
    return product.tags1?.some((tag) => tag === tagName)
}

export const hasTagStartingWith = (product, prefix) => {
    return product.tags1?.some((tag) => tag.startsWith(prefix))
}

export const findTagStartingWith = (product, prefix) => {
    return product.tags1?.find((tag) => tag.startsWith(prefix))
}

export const getCustomFieldValue = (product, key) => {
    return product.customFields?.find((field) => field.key === key)?.value
}

export const closeSearchHeader = () => {
    const closeButton = document.querySelector('.js-search-header-close')
    if (closeButton) {
        closeButton.click()
    }
}
